import { Permission } from '~/types/Permission';
import { User } from '~/types/User';

export const checkIsRbacAdmin: Permission = (user: User) => {
  return !!user.is_rbac_admin;
};
